var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBelgium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0H15.75V16.5H8.25V0Z",
    fill: "#FFDA24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 0C1.26488 0 0 1.84688 0 4.125V12.375C0 14.6531 1.26488 16.5 3.75 16.5H8.25V0H3.75Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0H15.75V16.5H20.25C22.7351 16.5 24 14.6531 24 12.375V4.125C24 1.8465 23.9843 0 19.5 0Z",
    fill: "#EF3340"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelgium);
export default __webpack_public_path__ + "static/media/belgium.7b1a649ae62d454f955f2a06580042e5.svg";
export { ForwardRef as ReactComponent };